
// @ts-nocheck
import locale_cs_46json_ff50fd2c from "#nuxt-i18n/ff50fd2c";
import locale_en_46json_0b63539c from "#nuxt-i18n/0b63539c";

export const localeCodes =  [
  "cs",
  "en"
]

export const localeLoaders = {
  cs: [
    {
      key: "locale_cs_46json_ff50fd2c",
      load: () => Promise.resolve(locale_cs_46json_ff50fd2c),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_0b63539c",
      load: () => Promise.resolve(locale_en_46json_0b63539c),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: false,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "cs",
      language: "cs-CZ",
      name: "Čeština",
      isCatchallLocale: true,
      files: [
        {
          path: "/app/i18n/locales/cs.json",
          cache: undefined
        }
      ]
    },
    {
      code: "en",
      language: "en-US",
      name: "English",
      files: [
        {
          path: "/app/i18n/locales/en.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "cs",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: false,
  differentDomains: false,
  baseUrl: "https://uap.iprpraha.cz/",
  customRoutes: "config",
  pages: {
    "mapy/index": {
      cs: "/mapy",
      en: "/maps"
    },
    "mapy/atlas": {
      cs: "/mapy/atlas",
      en: "/maps/atlas"
    },
    "mapy/katalog-lokalit.client": {
      cs: "/mapy/katalog-lokalit",
      en: "/maps/catalogue-of-localities"
    },
    "texty/index": {
      cs: "/texty",
      en: "/texts"
    },
    "texty/[...kody]": {
      cs: "/texty/[...kody]",
      en: "/texts/[...kody]"
    },
    "cisla/index": {
      cs: "/cisla",
      en: "/numbers"
    },
    "cisla/katalog-mestskych-casti/index": {
      cs: "/cisla/katalog-mestskych-casti",
      en: "/numbers/catalogue-of-municipal-districts"
    },
    "cisla/katalog-mestskych-casti/listy": {
      cs: "/cisla/katalog-mestskych-casti/listy",
      en: "/numbers/catalogue-of-municipal-districts/sheets"
    },
    "cisla/katalog-mestskych-casti/listy/[mestskaCastId]": {
      cs: "/cisla/katalog-mestskych-casti/listy/[mestskaCastId]",
      en: "/numbers/catalogue-of-municipal-districts/sheets/[mestskaCastId]"
    },
    "cisla/katalog-mestskych-casti/metriky": {
      cs: "/cisla/katalog-mestskych-casti/metriky",
      en: "/numbers/catalogue-of-municipal-districts/metrics"
    },
    "cisla/katalog-mestskych-casti/metriky/[metrikaId]": {
      cs: "/cisla/katalog-mestskych-casti/metriky/[metrikaId]",
      en: "/numbers/catalogue-of-municipal-districts/metrics/[metrikaId]"
    },
    "cisla/katalog-indikatoru-a-metrik": {
      cs: "/cisla/katalog-indikatoru-a-metrik",
      en: "/numbers/catalogue-of-indicators-and-metrics"
    },
    "cisla/katalog-indikatoru-a-metrik/[skupinaMetrikKod]": {
      cs: "/cisla/katalog-indikatoru-a-metrik/[skupinaMetrikKod]",
      en: "/numbers/catalogue-of-indicators-and-metrics/[skupinaMetrikKod]"
    },
    "cisla/pov": {
      cs: "/cisla/pov",
      en: "/numbers/pov"
    },
    "o-portalu/index": {
      cs: "/o-portalu",
      en: "/about"
    },
    "o-portalu/o-portalu-a-souvisejicich-aplikacich": {
      cs: "/o-portalu/o-portalu-a-souvisejicich-aplikacich",
      en: "/about/about-the-portal-and-related-applications"
    },
    "o-portalu/o-uzemne-analytickych-podkladech": {
      cs: "/o-portalu/o-uzemne-analytickych-podkladech",
      en: "/about/about-planning-analytical-materials"
    },
    "o-portalu/jevy-uap": {
      cs: "/o-portalu/jevy-uap",
      en: "/about/monitored-phenomena"
    },
    "o-portalu/kontakty": {
      cs: "/o-portalu/kontakty",
      en: "/about/contacts"
    },
    "ke-stazeni": {
      cs: "/ke-stazeni",
      en: "/download"
    },
    vyhledavani: {
      cs: "/vyhledavani",
      en: "/search"
    },
    "storymap/praha-prumyslova": {
      cs: "/storymap/praha-prumyslova",
      en: "/storymap/industrial-prague"
    },
    "storymap/praha-rozmanita": {
      cs: "/storymap/praha-rozmanita",
      en: "/storymap/diverse-prague"
    },
    "storymap/praha-airbnb": {
      cs: "/storymap/praha-airbnb",
      en: "/storymap/prague-airbnb"
    },
    "storymap/praha-udrzitelna": {
      cs: "/storymap/praha-udrzitelna",
      en: "/storymap/sustainable-prague"
    }
  },
  skipSettingLocaleOnNavigate: true,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "cs",
    language: "cs-CZ",
    name: "Čeština",
    isCatchallLocale: true,
    files: [
      {
        path: "/app/i18n/locales/cs.json",
        cache: undefined
      }
    ]
  },
  {
    code: "en",
    language: "en-US",
    name: "English",
    files: [
      {
        path: "/app/i18n/locales/en.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/